<script lang="ts" setup>
const _props = defineProps<{
  items: {
    _key?: string
    title?: string
    info?: string
    suffix?: string
  }[]
}>()

const amount = computed(() => (_props?.items.length > 4 ? 4 : _props?.items.length))
</script>

<template>
  <div class="grid w-full gap-5" :class="`lg:grid-cols-${amount}`">
    <!-- Regular items from props -->
    <div
      v-for="item in items"
      :key="item._key"
      class="flex items-center justify-between rounded-sm border border-(--theme-fg)/15 bg-(--theme-fg)/1 p-5 backdrop-blur-[10px] lg:flex-col lg:items-start"
    >
      <h6 class="text-bold text-sm uppercase">{{ item.title }}</h6>
      <span class="font-display flex text-xl lg:mt-6"
        >{{ item.info }} <span class="ml-1.5 text-base">{{ item.suffix }}</span></span
      >
    </div>
  </div>
</template>
